const echartsOptionsDMJ = [{
	numCharts: 1,
	barGap: '-100%',
	legend: {
		show: true,
		left: 'left',
		data: ["达成金额", "目标金额"],
		itemWidth: 24, // 设置图例图形的宽
		itemHeight: 8, // 设置图例图形的高
	},
	xAxisData: ['第一季度', '第二季度', '第三季度', '第四季度'],
	yAxis: {
		name: '单位：万元',
		splitArea: {
			show: false
		}
	},
	grid: {
		left: '3%',
		right: '4%',
		bottom: '15%',
		containLabel: true
	},
	series: [{
		barWidth: 32.5,
		data: [],
		emphasis: {
			focus: 'series',
		},
		itemStyle: {
			borderRadius: [3, 3, 0, 0, ], // 柱状图圆角
			borderWidth: 0,
			color: '#002B66',
		},
		//  label: {
		//     normal: {
		//         show: true,
		//         position: 'insideRight'
		//     }
		// },
		name: '达成金额',
		type: 'bar',

	}, {
		barGap: '-100%',
		/*这里设置包含关系，只需要这一句话*/
		barWidth: 32.5,
		data: [],
		emphasis: {
			focus: 'series',
		},
		itemStyle: {
			borderRadius: [3, 3, 0, 0, ], // 柱状图圆角
			borderWidth: 0,
			color: '#E71D43',
		},
		//  label: {
		//     normal: {
		//         show: true,
		//         position: 'insideRight'
		//     }
		// },
		name: '目标金额',
		type: 'bar',

	}]
}];
export default echartsOptionsDMJ;
